"use client";
/* eslint-disable @next/next/no-img-element */

import { useAppStore } from "@/store/app";
import shallow from "zustand/shallow";

export default function LoadingYourSongbookIndicator() {
  const { songsImporting } = useAppStore(
    ({ songsImporting }) => ({ songsImporting }),
    shallow,
  );
  if (!songsImporting) return null;
  return (
    <div className="w-screen h-screen z-50 top-0 absolute">
      <div className="fixed left-1/2 top-1/2 text-center z-[40] translate-x-[-50%] translate-y-[-50%]">
        <div className="relative h-[200px] w-[355.6px]">
          <img
            src="/LoadingYourSongBook-1.svg"
            className="absolute h-[50px] z-[2] left-[44%] top-[23%]"
            style={{ animation: "drawArc 2s linear infinite" }}
            alt="docs"
          />
          <img
            src="/LoadingYourSongBook-0.svg"
            className="h-[200px] block absolute"
            alt=""
          />
          <img
            src="/LoadingYourSongBook-2.svg"
            className="h-[200px] block absolute z-[2]"
            alt=""
          />
        </div>
        <h5 className="text-primary">Loading your songbook…</h5>
      </div>
    </div>
  );
}
